import * as React from 'react'

const CompanyFundsContext = React.createContext([])

export default CompanyFundsContext
